import React from 'react';
import LockOutlineRoundedIcon from '@mui/icons-material/LockOutlineRounded';

type Props = {
  readonly: boolean;
};

export default function ReadonlyNote({ readonly }: Props) {
  return readonly ? (
    <div className="text-xs text-gray-500 flex items-center gap-1">
      <LockOutlineRoundedIcon className="!w-4 !h-4" />
      <span className="font-medium mt-0.5">Read-only view — created by another user</span>
    </div>
  ) : null;
}
